import { render, staticRenderFns } from "./TransferenciaPosseForm.vue?vue&type=template&id=332ff4f5&"
import script from "./TransferenciaPosseForm.vue?vue&type=script&lang=js&"
export * from "./TransferenciaPosseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/transferencia-posse/TransferenciaPosseForm.vue
// module id = 1566
// module chunks = 28